let scannerModulePromise;

export async function loadHtml5Qrcode() {
  if (!scannerModulePromise) {
    scannerModulePromise = import('html5-qrcode').then((module) => ({
      Html5Qrcode: module.Html5Qrcode,
      Html5QrcodeSupportedFormats: module.Html5QrcodeSupportedFormats,
      Html5QrcodeScannerState: module.Html5QrcodeScannerState,
    }));
  }

  return scannerModulePromise;
}
